import React, { useState } from "react";
import * as signalR from "@microsoft/signalr";
import { HttpTransportType } from '@microsoft/signalr';

const TokenEntryScreen = () => {
    const [token, setToken] = useState("");
    const [doctor, setDoctor] = useState("");
    const [counter, setCounter] = useState("");
    const [connection, setConnection] = useState(null);

    // Establish SignalR connection on component load
    React.useEffect(() => {
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl("https://www.tokenapi.binix.co.in/hubs/chat", {
                withCredentials: true, // Ensure credentials (cookies) are included
                transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
            }) // Your SignalR hub URL
            .withAutomaticReconnect()
            .build();

        /* const newConnection = new signalR.HubConnectionBuilder()
            .withUrl("http://localhost:44389/hubs/chat", {
                withCredentials: true, // Ensure credentials (cookies) are included
                transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
            }) // Your SignalR hub URL
            .withAutomaticReconnect()
            .build(); */

        newConnection
            .start()
            .then(() => {
                console.log("SignalR Connected (Token Entry Screen)");
                setConnection(newConnection);
            })
            .catch((error) => console.error("SignalR Connection Error:", error));
    }, []);

    // Function to send token to the hub
    const sendToken = () => {
        if (!doctor) {
            alert("Please select a doctor.");
            return;
        }
        if (connection && token) {
            debugger;
            console.log(doctor);
            const tokenData = {
                Key: counter + '-' + token,
                TokenNo: token,  // Token number
                DrName: doctor || 'Dr. Not selected',
                Description: 'Description',    // Description
                Counter: counter,    // Counter No
                Language: 'hi-IN'     // Patient's name
            };

            connection
                .invoke("SendToken", tokenData) // Call the "SendToken" method on the hub
                .then(() => {
                    console.log("Token sent:", token);
                    setToken("");
                })
                .catch((err) => console.error("Error sending token:", err));
        }
    };


    const handleDoctorChange = (e) => {
        const selectedIndex = e.target.selectedIndex;
        const selectedText = e.target.options[selectedIndex].text;
        const selectedValue = e.target.value;

        setCounter(selectedValue);
        setDoctor(selectedText);
    };


    return (
        <div>
            <h1>Token Entry Screen</h1>
            <input
                type="text"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Enter Token Number"
            />
            <select value={counter} onChange={handleDoctorChange}>
                <option value="" disabled>Select Doctor</option>
                <option value="1" >Dr. Dinesh</option>
                <option value="2">Dr. Raj Kumar</option>
                <option value="3">Dr. Rituraj</option>
            </select>
            <button onClick={sendToken}>Send Token</button>
        </div>
    );
};

export default TokenEntryScreen;
